var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-section"},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":"/img/naccu_logo.svg"}})])])
}]

export { render, staticRenderFns }